import { ComboBox } from '@reveni-io/reveni-ui'

const RegionSelector = ({ regions, value, onChange, label }) => {
  if (!regions?.length) return null

  return (
    <ComboBox
      value={value}
      handleChange={e => onChange(e.target.value)}
      menuItems={regions?.map(r => ({ label: r.name, value: r.code }))}
      label={label}
    />
  )
}

export default RegionSelector
